export default __webpack_public_path__ + "static/media/ws.63653e93.svg";